// extracted by mini-css-extract-plugin
module.exports = {"tiptap":"tiptapStyles_tiptap__Dxzgz","editorContentWrapper":"tiptapStyles_editorContentWrapper__R2gfx"};